import GradeBoundaryAlert from "../../../components/GradeBoundaryAlert";

export default function FlowGradeGuidance({ grade, neededText, pointsAboveBoundary }) {
  if (grade == null) return null;
  return (
    <div className="subject-guidance" aria-label="Grade boundary guidance">
      {neededText && <p>{neededText}</p>}
      <GradeBoundaryAlert grade={grade} pointsAboveBoundary={pointsAboveBoundary} appearance="quiet" />
    </div>
  );
}
